<button type="button" [id]="question.addButtonId" *ngIf="question.canAddPanel" [class]="question.getAddButtonCss()" [disabled]="!isActionEnabled" (click)="addPanelClick()">
<span [class]="question.cssClasses.buttonAddText"><sv-ng-string [model]="question.locAddPanelText"></sv-ng-string></span>
</button>